module.exports = __webpack_public_path__ + "media/customizations/regencyatoldetowne/logo-new-2168673f932be1a101056134c7c4c31e.png";